<template>
    <div class="fleet-setup-step-title">
        <h1 class="my-0">
            {{title}}
        </h1>
        <p class="mt-2 mb-1 td-text-subdued">{{para1}}</p>
        <p class="mt-1 td-text-subdued">
            {{para2}}
        </p>
    </div>
</template>

<script>
import script from './StepTitle';
    export default script;</script>

<style lang="less">
    @import "./StepTitle.less";
</style>